
<div class="mt-3 mb-3">
    <h4>{{ 'APP.TITULO' | translate }}</h4>
</div>
<app-buscador-polizas></app-buscador-polizas>